import { Component, OnInit } from '@angular/core';
import { TestlistService } from '@app-services/test/testlist.service';
import { ExamService } from '@app-services/test/exam.service';
import { doLegendWiseQuestionCountCalculation } from '@app-modules/feature/dashboard/component/exam-page/submit-confirmation/submit-confirmation.component';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { viewTestReport } from '@app-modules/feature/dashboard/component/new-test-list/new-test-list.component';
import { Router } from '@angular/router';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { UserService } from '@app-services/user/user.service';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { getMomentUTCtime } from '@app-helpers/functions';

@Component({
  selector: 'app-timeboundoverviewreport',
  templateUrl: './timeboundoverviewreport.component.html',
  styleUrls: ['./timeboundoverviewreport.component.css']
})
export class TimeboundoverviewreportComponent implements OnInit {

  subject_overView: any = [];
  examEndtimeWithreportGrace: any;
  private destroy$ = new Subject<boolean>();
  public timerFormat = new Subject<any>();
  showReport:boolean = false;
  testData:any = {}
  timerInmilliSecs = 0;
  viewTestReport = viewTestReport;
  getMomentUTCtime =getMomentUTCtime;
  userData;
  testRecordData :any ={}
  constructor(public testlistService: TestlistService, public examService: ExamService,public router:Router,private firebaseService: FirebaseService,private userService: UserService) { }

  ngOnInit(): void {
    this.userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    const data = this.examService.getPresentExamInfo();
    this.testData = data;
    this.testData.timeFormat =data?.examstartedon?new Date(data?.examstartedon):new Date(data?.span)
    console.log("🚀 ~ file: timeboundoverviewreport.component.ts:32 ~ TimeboundoverviewreportComponent ~ ngOnInit ~ this.testData:", this.testData)
    const detail = JSON.parse(localStorage.getItem('mobile_and_name') as string) || {}
    const postdata = { "ruleid": data?.id, "phone": detail?.phone, "attempt": data?.attempt }
    this.testlistService.scoreTestReport(postdata).subscribe((response: any) => {
      this.testRecordData = response;
      let percen = ((response?.totalScore||0)/(response?.outOfScore||0))*100
      this.testRecordData.animationgifPercentage = percen < 30 ?'improve-star-animation.gif':(((percen > 30|| percen == 30) && (percen < 75|| percen == 75)) ?'good-star-animation.gif' :'strong-star-animation.gif')
      // this.testlistService.getServerTime().then((time) => {
        localStorage.setItem('serverTime',this.getMomentUTCtime()); 
        let current_time = moment.utc()//this.getMomentUTCtime()
      this.examEndtimeWithreportGrace = moment(new Date(response?.examStartTime)).add(((response?.examDuration || 0) + 5), 'minutes')
        
        if (this.examEndtimeWithreportGrace.diff(current_time, 'seconds') > 0) {
          this.timerInmilliSecs = this.examEndtimeWithreportGrace.diff(current_time, 'milliseconds')
          this.timerStarts()
        }else{
          this.showReport = true
        }
      // })
      
      this.subject_overView = response?.testSubjects.map(v=>{
       const per = (v?.totalScore/v?.outOfScore)*100;
      
        v.percentage =(per > 0 || per === 0) ? per :(per < 0)?5:0,
        v.subjectClass = (per > 0)? v?.subjectName?.toLowerCase()?.replace(' ','') :(per < 0|| per ===0)?'grey':''
        return v 
      });
      this.sendLSQData(response,this.testData);
    })
  }
  timerStarts() {
    timer(0, 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(n => {
        if ((this.timerInmilliSecs - 1000) > 0 || (this.timerInmilliSecs - 1000) == 0) {
          this.timerInmilliSecs = this.timerInmilliSecs - 1000;
          var time = `${moment.duration(this.timerInmilliSecs, 'milliseconds').hours()}h  :
                         ${moment.duration(this.timerInmilliSecs, 'milliseconds').minutes()}m :
                         ${moment.duration(this.timerInmilliSecs, 'milliseconds').seconds()}s `
          this.timerFormat.next(time);
        } else {
          this.showReport = true;
          this.destroy$.next(false)
          this.timerFormat.next(false);
          
        }
      });
  }
  ngOnDestroy() {
    this.timerFormat.next(false)
    this.destroy$.next(false)
  }
  sendLSQData(examinfo,ruleInfo){
    localStorage.setItem('answeredQues',JSON.stringify(0));
    // let subjects ='';
    // let sendDataFlag = JSON.parse(localStorage.getItem('answeredQues'));
    // let  firebasePayload = {
    //   "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
    //   "ActivityEvent": 261,
    //   "Fields":{},
    //   "FirstName": this.userData?.firstName,
    //   "LastName": this.userData?.lastName,
    //   "environment": environment?.branch,
    //   "phone": this.userData?.phone,
    //   "productId": 1,
    //   "type": "Activity"
    // }
    // examinfo?.testSubjects?.forEach(element => {
    //    subjects+=element?.subjectName+',';
    // });

    // this.firebaseService.getSqsValue().then((firebaseRSP) => {
    //   firebasePayload.Fields = {
    //     mx_Custom_10:examinfo?.testname,
    //     mx_Custom_9:'Submitted',
    //     mx_Custom_8: ruleInfo?.rulename,
    //     mx_Custom_1:examinfo?.totalScore+'/'+examinfo?.outOfScore,
    //     mx_Custom_3: examinfo?.rank,
    //     mx_Custom_13: subjects,
    //     // schedulename:this.examinfo.schedulename,
    //     mx_Custom_2:examinfo?.percentile,
    //     // mx_Custom_11:experience,
    //     // mx_Custom_12:difficultylevel,
    //   }
    //   if(sendDataFlag && sendDataFlag > 9){
    //     this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
    //     localStorage.setItem('answeredQues',JSON.stringify(0));
    //   }
    // }).catch((e) => {
    //   console.log(e);
    //   localStorage.setItem('answeredQues',JSON.stringify(0));
    // });
  }

  goBack(){
    this.router.navigateByUrl(`/dashboard/testlist?examname=${localStorage.getItem('targetExamName')}&examtype=${this.testData.examtype}`);
  }
}
